export default Object.freeze({
  UNAUTHENTICATED: "UNAUTHENTICATED",
  AMBASSADOR: "ambassador",
  PROSPECT: "prospect",
});
